module.exports = __webpack_public_path__ + "assets/warning-53efd2.svg";